<template>
  <section>
    <List
      :title="table.title"
      :breadcumb="table.breadcumb"
      :dataTable="table.dataTable"
      :showPagination="false"
    >
      <template v-slot:button>
        <div>
          <button
            type="button"
            class="btn btn-primary"
            data-toggle="modal"
            data-target="#Modal_TambahUraianProsesAmandemen"
          >
            <i class="fa fa-plus fa-l" aria-hidden="true"></i> Tambah Uraian
            Proses Amandemen
          </button>
        </div>
      </template>

      <template v-slot:search>
        <div class="input-group form-search-rounded">
          <input
            class="form-control py-2 border-right-0 border"
            v-model.lazy="search"
            type="search"
            id="example-search-input"
            placeholder="Cari uraian proses amandemen disini.."
          />
          <span class="input-group-append">
            <div class="input-group-text bg-transparent">
              <a href="#" class="text-blue"><i class="fa fa-search"></i></a>
            </div>
          </span>
        </div>
      </template>

      <template v-slot:filter>
        <ul class="nav nav-tabs mb-2">
          <li
            class="nav-item"
            v-for="type in amendmentTypes"
            :key="type.value"
          >
            <button
              type="button"
              class="nav-link"
              :class="{ active: activeJenisAmandemen === type.value }"
              @click="changeJenisAmandemen(type.value)"
            >
              {{ type.label }}
            </button>
          </li>
        </ul>
      </template>

      <template v-slot:columnHeader>
        <thead>
          <tr>
            <th>No.</th>
            <th>Nama</th>
            <th>Jenis Amandemen</th>
            <th width="10%">Aksi</th>
          </tr>
        </thead>
      </template>

      <template v-slot:body="{ rows }">
        <tbody>
          <tr
            v-for="(data, index) in rows"
            :key="data.id"
            :draggable="!isLockedRow(data) && !isUpdatingLevel"
            @dragstart="onDragStart(index, data)"
            @dragend="onDragEnd"
            @dragenter.prevent="onDragEnter(index, data)"
            @dragleave="onDragLeave(index)"
            @dragover.prevent
            @drop="onDrop(index, data)"
            :class="{
              'dragging-row': dragIndex === index,
              'drop-target-row': dropTargetIndex === index && dragIndex !== index,
              'locked-row': isLockedRow(data),
            }"
            :style="{ cursor: isLockedRow(data) ? 'not-allowed' : 'move' }"
          >
            <td>{{ index + 1 }}</td>
            <td>
              <i
                v-if="isLockedRow(data)"
                class="fa fa-lock text-muted mr-50"
                aria-hidden="true"
              ></i>
              <span v-html="data.name"></span>
            </td>
            <td class="text-capitalize">{{ data.jenis_amandemen }}</td>
            <td>
              <div class="btn-action-block">
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#Modal_DataUraianProsesAmandemen"
                  @click="detail = JSON.parse(JSON.stringify(data))"
                  class="btn btn-icon-small btn-success-trans waves-effect waves-light"
                >
                  <i class="fa fa-eye"></i>
                </button>
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#Modal_EditUraianProsesAmandemen"
                  @click="detail = JSON.parse(JSON.stringify(data))"
                  class="btn btn-icon-small btn-warning-trans waves-effect waves-light"
                  style="margin-left: 2px"
                >
                  <i class="fa fa-pencil"></i>
                </button>
                <button
                  type="button"
                  @click="destroy(data)"
                  class="btn btn-icon-small btn-danger-trans waves-effect waves-light"
                  id="confirm-text"
                  style="margin-left: 2px"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </template>

      <template v-slot:action="{ data }">
        <div class="btn-action-block">
          <button
            type="button"
            data-toggle="modal"
            data-target="#Modal_DataUraianProsesAmandemen"
            @click="detail = JSON.parse(JSON.stringify(data))"
            class="btn btn-icon-small btn-success-trans waves-effect waves-light"
          >
            <i class="fa fa-eye"></i>
          </button>
          <button
            type="button"
            data-toggle="modal"
            data-target="#Modal_EditUraianProsesAmandemen"
            @click="detail = JSON.parse(JSON.stringify(data))"
            class="btn btn-icon-small btn-warning-trans waves-effect waves-light"
            style="margin-left: 2px"
          >
            <i class="fa fa-pencil"></i>
          </button>
          <button
            type="button"
            @click="destroy(data)"
            class="btn btn-icon-small btn-danger-trans waves-effect waves-light"
            id="confirm-text"
            style="margin-left: 2px"
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </template>
    </List>

    <!-- Modal Tambah -->
    <div
      class="modal fade text-left"
      id="Modal_TambahUraianProsesAmandemen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel160"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header modal-primary white">
            <h5 class="modal-title" id="myModalLabel160">
              Tambah Uraian Proses Amandemen
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ValidationObserver v-slot="{ invalid }" ref="observer">
            <div class="modal-body">
              <ValidationProvider
                name="Nama"
                v-slot="{ errors }"
                rules="required"
              >
                <div
                  class="form-group"
                  :class="{ 'validation-warning': errors[0] }"
                >
                  <label for="">Nama Uraian Proses</label>
                  <input
                    type="text"
                    v-model="model.name"
                    class="form-control"
                    placeholder="Masukan nama uraian proses"
                    aria-describedby="helpId"
                    required=""
                  />
                  <small class="text-muted" v-if="errors[0]">{{
                    errors[0]
                  }}</small>
                </div>
              </ValidationProvider>
              <ValidationProvider
                name="Jenis Amandemen"
                v-slot="{ errors }"
                rules="required"
              >
                <div
                  class="form-group"
                  :class="{ 'validation-warning': errors[0] }"
                >
                  <label for="">Jenis Amandemen</label>
                  <select
                    v-model="model.jenis_amandemen"
                    class="custom-select form-control"
                  >
                    <option value="" selected>Pilih Jenis Amandemen</option>
                    <option value="unit">Unit</option>
                    <option value="pusat">Pusat</option>
                  </select>
                  <small class="text-muted" v-if="errors[0]">{{
                    errors[0]
                  }}</small>
                </div>
              </ValidationProvider>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-primary"
                data-dismiss="modal"
              >
                Tutup
              </button>
              <button
                type="button"
                :disabled="invalid"
                @click="save()"
                class="btn btn-primary"
                data-dismiss="modal"
              >
                Tambah
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- Modal Edit -->
    <div
      class="modal fade text-left"
      id="Modal_EditUraianProsesAmandemen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel160"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header modal-primary white">
            <h5 class="modal-title" id="myModalLabel160">
              Edit Uraian Proses Amandemen
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ValidationObserver v-slot="{ invalid }" ref="observerEdit">
            <div class="modal-body">
              <ValidationProvider
                name="Nama"
                v-slot="{ errors }"
                rules="required"
              >
                <div
                  class="form-group"
                  :class="{ 'validation-warning': errors[0] }"
                >
                  <label for="">Nama Uraian Proses</label>
                  <input
                    type="text"
                    v-model="detail.name"
                    class="form-control"
                    placeholder="Masukan nama uraian proses"
                    aria-describedby="helpId"
                    required=""
                  />
                  <small class="text-muted" v-if="errors[0]">{{
                    errors[0]
                  }}</small>
                </div>
              </ValidationProvider>
              <ValidationProvider
                name="Jenis Amandemen"
                v-slot="{ errors }"
                rules="required"
              >
                <div
                  class="form-group"
                  :class="{ 'validation-warning': errors[0] }"
                >
                  <label for="">Jenis Amandemen</label>
                  <select
                    v-model="detail.jenis_amandemen"
                    class="custom-select form-control"
                  >
                    <option value="" selected>Pilih Jenis Amandemen</option>
                    <option value="unit">Unit</option>
                    <option value="pusat">Pusat</option>
                  </select>
                  <small class="text-muted" v-if="errors[0]">{{
                    errors[0]
                  }}</small>
                </div>
              </ValidationProvider>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-primary"
                data-dismiss="modal"
              >
                Tutup
              </button>
              <button
                type="button"
                :disabled="invalid"
                @click="update()"
                class="btn btn-primary"
                data-dismiss="modal"
              >
                Simpan
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- Modal Detail -->
    <div
      class="modal fade text-left"
      id="Modal_DataUraianProsesAmandemen"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header modal-primary white">
            <h5 class="modal-title">Data Uraian Proses Amandemen</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="">Nama Uraian Proses</label>
              <input
                type="text"
                class="form-control"
                :value="detail.name"
                readonly
              />
            </div>
            <div class="form-group">
              <label for="">Jenis Amandemen</label>
              <input
                type="text"
                class="form-control text-capitalize"
                :value="detail.jenis_amandemen"
                readonly
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-primary"
              data-dismiss="modal"
            >
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import List from "@/components/List.vue";

export default {
  name: "UraianProsesAmandemenIndex",
  components: {
    List,
  },
  data() {
    return {
      table: {
        title: "Uraian Proses Amandemen",
        breadcumb: "Master Data",
        dataTable: {
          lists: [],
          columns: ["name", "jenis_amandemen"],
        },
      },
      search: null,
      detail: {
        name: null,
        jenis_amandemen: null,
      },
      model: {
        name: null,
        jenis_amandemen: "",
      },
      amendmentTypes: [
        { label: "Unit", value: "unit" },
        { label: "Pusat", value: "pusat" },
      ],
      activeJenisAmandemen: "unit",
      dragIndex: null,
      dropTargetIndex: null,
      isUpdatingLevel: false,
    };
  },
  mounted() {
    let _ = this;
    _.getList();
  },
  methods: {
    getList() {
      let _ = this;
      _.axios
        .get(
          "/v3/amandemen-uraian-proses?key=" +
            encodeURIComponent(_.search || "") +
            "&jenis_amandemen=" +
            _.activeJenisAmandemen +
            "&page=1&per_page=999",
        )
        .then((resp) => {
          const rows = resp.data.data.rows;
          if (Array.isArray(rows.data)) {
            rows.data = rows.data.sort(
              (a, b) => Number(a.level || 0) - Number(b.level || 0),
            );
          }
          _.table.dataTable.lists = rows;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    changeJenisAmandemen(type) {
      if (this.activeJenisAmandemen === type) {
        return;
      }

      this.activeJenisAmandemen = type;
      this.dragIndex = null;
      this.dropTargetIndex = null;
      this.getList();
    },
    isLockedRow(data) {
      return (data?.name || "").trim().toLowerCase() === "amandemen terbit";
    },
    onDragStart(index, data) {
      if (this.isLockedRow(data) || this.isUpdatingLevel) {
        return;
      }

      this.dragIndex = index;
    },
    onDragEnd() {
      this.dragIndex = null;
      this.dropTargetIndex = null;
    },
    onDragEnter(index, data) {
      if (
        this.dragIndex === null ||
        this.dragIndex === index ||
        this.isLockedRow(data)
      ) {
        return;
      }

      this.dropTargetIndex = index;
    },
    onDragLeave(index) {
      if (this.dropTargetIndex === index) {
        this.dropTargetIndex = null;
      }
    },
    onDrop(dropIndex, data) {
      if (
        this.dragIndex === null ||
        this.isUpdatingLevel ||
        this.isLockedRow(data)
      ) {
        return;
      }

      const fromIndex = this.dragIndex;
      this.dragIndex = null;
      this.dropTargetIndex = null;

      if (fromIndex === dropIndex) {
        return;
      }

      const list = this.table.dataTable.lists?.data;
      if (!Array.isArray(list)) {
        return;
      }

      const reordered = [...list];
      const [movedItem] = reordered.splice(fromIndex, 1);
      reordered.splice(dropIndex, 0, movedItem);

      const lockedRowShifted = list.some((item, index) => {
        if (!this.isLockedRow(item)) {
          return false;
        }

        return reordered[index]?.id !== item.id;
      });

      if (lockedRowShifted) {
        this.$toast.warning("Posisi Amandemen Terbit tidak dapat dipindahkan");
        return;
      }

      this.table.dataTable.lists.data = reordered.map((item, index) => ({
        ...item,
        level: index + 1,
      }));

      this.bulkUpdateLevel();
    },
    bulkUpdateLevel() {
      const _ = this;
      const list = _.table.dataTable.lists?.data || [];
      const payload = {
        jenis_amandemen: _.activeJenisAmandemen,
        items: list.map((item, index) => ({
          id: item.id,
          level: index + 1,
        })),
      };

      _.isUpdatingLevel = true;
      _.axios
        .post("/v3/amandemen-uraian-proses/bulk-update-level", payload)
        .then((resp) => {
          if (resp.status) {
            _.$toast.success("Urutan uraian proses berhasil diubah");
            _.getList();
            return;
          }

          _.$toast.warning("Urutan uraian proses gagal diubah");
          _.getList();
        })
        .catch((err) => {
          console.log(err.response);
          _.$toast.warning(
            err.response?.data?.message || "Urutan uraian proses gagal diubah",
          );
          _.getList();
        })
        .finally(() => {
          _.isUpdatingLevel = false;
        });
    },
    save() {
      let _ = this;
      _.axios
        .post("/v3/amandemen-uraian-proses", _.model)
        .then((resp) => {
          if (resp.status) {
            _.getList();
            _.$toast.success("Data Berhasil Disimpan");
          } else {
            _.$toast.warning("Data Gagal Disimpan");
          }
          _.model = {
            name: null,
            jenis_amandemen: "",
          };
          _.$refs.observer.reset();
        })
        .catch((err) => {
          console.log(err.response);
          _.model = {
            name: null,
            jenis_amandemen: "",
          };
          _.$refs.observer.reset();
          _.$toast.warning(
            err.response?.data?.message || "Data Gagal Disimpan",
          );
        });
    },
    update() {
      let _ = this;
      _.axios
        .put("/v3/amandemen-uraian-proses/" + _.detail.id, _.detail)
        .then((resp) => {
          if (resp.status) {
            _.getList();
            _.$toast.success("Data Berhasil Diubah");
          } else {
            _.$toast.warning("Data Gagal Diubah");
          }
          _.$refs.observerEdit.reset();
        })
        .catch((err) => {
          console.log(err.response);
          _.$refs.observerEdit.reset();
          _.$toast.warning(err.response?.data?.message || "Data Gagal Diubah");
        });
    },
    destroy(x) {
      let _ = this;
      this.$swal
        .fire({
          title: "Hapus Data Ini?",
          text: "Anda mungkin tidak akan mengembalikannya lagi!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#44A8BD",
          cancelButtonColor: "#D95E6A",
          confirmButtonText: "Ya, Hapus!",
          cancelButtonText: "Batal",
        })
        .then((result) => {
          if (result.value) {
            _.axios
              .delete("/v3/amandemen-uraian-proses/" + x.id)
              .then((resp) => {
                if (resp.status) {
                  _.getList();
                  this.$swal.fire({
                    title: "Terhapus!",
                    text: "Data berhasil dihapus",
                    icon: "success",
                    confirmButtonColor: "#37BA71",
                    confirmButtonText: "OK",
                  });
                }
              })
              .catch((err) => {
                console.log(err.response);
                _.$toast.warning(
                  err.response?.data?.message || "Data Gagal Dihapus",
                );
              });
          }
        });
    },
  },
  watch: {
    search: function () {
      this.getList();
    },
  },
};
</script>

<style scoped>
.drop-target-row {
  background-color: #e8f4ff;
  outline: 2px dashed #44a8bd;
  outline-offset: -2px;
}

.locked-row {
  background-color: #f8f9fa;
}

.nav-tabs .nav-link {
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  color: #626262;
}

.nav-tabs .nav-link.active {
  border-bottom-color: #44a8bd;
  color: #44a8bd;
  font-weight: 600;
}
</style>
